import { render } from "./VuexTextareaFormItem.vue?vue&type=template&id=e34d4a3c"
import script from "./VuexTextareaFormItem.vue?vue&type=script&lang=js"
export * from "./VuexTextareaFormItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__